<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->
<div class="search-n-download">
  <div class="lf-search-container">
    <span class="far fa-search cursor-pointer"></span>
    <img
      src="assets/img/svgs/normal_clear_u481.svg"
      class="clear-img"
      (click)="clearSearch()"
      *ngIf="employeeSearch.value !== ''"
    />
    <input
      #employeeSearch
      type="text"
      class="form-control"
      placeholder="Search"
      [(ngModel)]="searchValue"
      (ngModelChange)="searchInputChange($event)"
    />
  </div>
  <div class="lf-btn-download-container">
    <i
      class="fal fa-arrow-to-bottom"
      tooltipClass="lf-box-tooltip"
      ngbTooltip="Download CSV"
      (click)="
        activeTab === 'Attended' ? exportAttendedData() : exportSpokenData()
      "
    ></i>
  </div>
</div>
<div
  class="lf-nav-tabs"
  *ngIf="{
    attended: attendedPageData$ | async,
    spoken: spokenPageData$ | async
  } as pageData"
>
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs"
    [activeId]="activeTab"
    (navChange)="activeTab = $event.nextId"
  >
    <ng-container [ngbNavItem]="'Attended'">
      <a ngbNavLink class="tab-name"
        >Events Attended ({{
          isAttendedLoading ? '-' : attendedCollectionSize
        }})</a
      >
      <ng-template ngbNavContent>
        <lfx-new-table
          [columns]="attendedColumns"
          [data]="pageData.attended || []"
          [version]="2"
          class="mb-4"
          [selectable]="false"
          [emptyDataMessage]="
            isAttendedLoading ? '' : 'No Activites found in this period.'
          "
        ></lfx-new-table>
        <lfx-ngb-pagination-wrapper
          *ngIf="attendedCollectionSize > 0"
          [collectionSize]="attendedCollectionSize"
          [page]="attendedPage$ | async"
          (pageChange)="onAttendedPageChange($event)"
          [pageSize]="attendedPageSize"
        ></lfx-ngb-pagination-wrapper>
      </ng-template>
    </ng-container>
    <ng-container [ngbNavItem]="'Spoken'">
      <a ngbNavLink class="tab-name"
        >Events Spoken At ({{
          isSpokenLoading ? '-' : spokenCollectionSize
        }})</a
      >
      <ng-template ngbNavContent>
        <lfx-new-table
          [columns]="spokenColumns"
          [data]="pageData.spoken || []"
          [version]="2"
          class="mb-4"
          [selectable]="false"
          [emptyDataMessage]="
            isSpokenLoading ? '' : 'No Activites found in this period.'
          "
        ></lfx-new-table>
        <lfx-ngb-pagination-wrapper
          *ngIf="spokenCollectionSize > 0"
          [collectionSize]="spokenCollectionSize"
          [page]="spokenPage$ | async"
          (pageChange)="onSpokenPageChange($event)"
          [pageSize]="spokenPageSize"
        ></lfx-ngb-pagination-wrapper>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class=""></div>
</div>
